import type { MediaFolderDto } from '../../data/dto/media-folder.dto.ts'

const pathFromPathChain = (pathChain: MediaFolderDto[]): string =>
  pathChain
    .reverse()
    .map(({ folderName }) => (folderName === 'root' ? '' : folderName))
    .join('/')

export default pathFromPathChain
